// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fOx7C{display:flex;flex-direction:column;gap:8px;margin-top:8px;width:100%}.ZDvss{display:flex;align-items:center;gap:12px}.Dl2nk{transition:opacity 150ms ease-in-out}.Dl2nk.XwZE7{opacity:.55}.yt1ns{display:flex;flex-direction:column;gap:8px;animation:XxkDo 200ms ease-in-out}.dHZzP{align-self:flex-start;margin-block-start:4px;margin-inline-end:16px}.lskJE{margin-top:8px}.iHI33{max-height:64px;overflow:hidden;transition:opacity 250ms ease-in-out,max-height 250ms ease-in-out,margin-top 250ms ease-in-out}.iHI33.Xi6hW{max-height:0;margin-top:0;opacity:0;pointer-events:none}@keyframes XxkDo{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:translateY(0)}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `fOx7C`,
	"rateRow": `ZDvss`,
	"thumb": `Dl2nk`,
	"dimmed": `XwZE7`,
	"revealed": `yt1ns`,
	"feedbackReveal": `XxkDo`,
	"submitButton": `dHZzP`,
	"success": `lskJE`,
	"confirmation": `iHI33`,
	"leaving": `Xi6hW`
};
export default ___CSS_LOADER_EXPORT___;
